import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';
import { PicturesBaseService } from './pictures-base.service';

/**
 * Project pictures service
 */
@Injectable({
  providedIn: 'root'
})
export class ProjectPicturesService extends PicturesBaseService {
  /**
   * Constructor
   * @param appServiceHelper AppServiceHelperService
   * @param httpClient HttpClient
   */
  constructor(appServiceHelper: AppServiceHelperService, httpClient: HttpClient) {
    super(appServiceHelper, httpClient, 'pollux.projectValuation.api', 'pollux.api', 'projects', 'projectId');
  }
}
